import { getContext } from '@/context';

/**
 * Get API headers without Authorization.
 * Used for public endpoints like library/CMS that don't require auth.
 */
const getPublicHeaders = (): HeadersInit => {
  const headers = { ...getContext().utils.api.getHeaders() };
  delete (headers as Record<string, unknown>).Authorization;
  return headers;
};

export default getPublicHeaders;
